/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES プレスリリースエディタ API
 * PR TIMES 企業管理画面 プレスリリースエディタ用の API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Google Natural Language API analyze entities リクエストボディ
 * @export
 * @interface NaturalLanguageAnalyzeEntitiesRequestBody
 */
export interface NaturalLanguageAnalyzeEntitiesRequestBody {
    /**
     * 解析する文字列データ
     * @type {string}
     * @memberof NaturalLanguageAnalyzeEntitiesRequestBody
     */
    text: string;
}

export function NaturalLanguageAnalyzeEntitiesRequestBodyFromJSON(json: any): NaturalLanguageAnalyzeEntitiesRequestBody {
    return NaturalLanguageAnalyzeEntitiesRequestBodyFromJSONTyped(json, false);
}

export function NaturalLanguageAnalyzeEntitiesRequestBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): NaturalLanguageAnalyzeEntitiesRequestBody {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'text': json['text'],
    };
}

export function NaturalLanguageAnalyzeEntitiesRequestBodyToJSON(value?: NaturalLanguageAnalyzeEntitiesRequestBody | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'text': value.text,
    };
}

